
// ✅ src/data/servicesData.js

export const servicesData = [
  {
    id: 1,
    title: "Portfolio Holdings",
    image: "../assets/services/experience.png",
    description: "Acquiring and managing equity stakes in a wide range of companies"
  },
  {
    id: 2,
    title: "Capital Distribution",
    image: "../assets/services/digital.png",
    description:
      "Allocating investor funds through structured financial instruments including shares, bonds, and equity options"
  },
  {
    id: 3,
    title: "Startup & VC Rounds",
    image: "../assets/services/platforms.png",
    description:
      "Leading investment rounds from seed and angel stages to Series A/B/C, with strategic exits via equity sales or IPOs."
  },
  {
    id: 4,
    title: "Growth Stewardship",
    image: "../assets/services/mlai.png",
    description:
      "Actively participating in the management of portfolio companies to ensure optimal growth trajectories and long-term value creation.."
 },
  {
    id: 5,
    title: "Active Governance",
    image: "../assets/services/mlai.png",
    description:
      "Direct involvement in portfolio company management, including board seats, strategic advisory, and performance monitoring aligned with growth trajectories."
    },
  {
    id: 6,
    title: "Risk Mitigation",
    image: "../assets/services/mlai.png",
    description:
      "Rigorous due diligence, sector diversification, hedging strategies, and adaptive capital allocation to safeguard investor capital."
    }
,
  {
    id: 7,
    title: "Strategic Exits  ",
    image: "../assets/services/mlai.png",
    description:
      "Timely divestments via secondary sales, mergers, acquisitions, or IPOs, with exit modeling and scenario planning to maximize returns."
    }
,
  {
    id: 8,
    title: "Operational Optimization",
    image: "../assets/services/mlai.png",
    description:
      "Support in finance, HR, and technology systems to streamline operations and improve EBITDA across portfolio companies."
    }
,

  {
    id: 9,
    title: "Brand & Positioning Strategy",
    image: "../assets/services/mlai.png",
    description:
      "Assistance with brand architecture, investor decks, and market positioning to attract strategic capital and partnerships."
    }

];






// avisoryServices
export const advisoryData = [
{id: 1,
    name: "Equity Structuring & Financial Instruments",
    image: "../assets/industries/agriculture.png",
    description:
      "Expertise in cap table design, convertible notes, SAFE agreements, preferred equity, and hybrid instruments tailored to investor and founder needs."
    },

    
    {

id: 3,
    name: "End-to-end support for mergers, acquisitions, and joint ventures ",
    image: "../assets/industries/agriculture.png",
    description:
      "From valuation and term sheet negotiation to post-deal integration."
    },
    {
id: 4,
    name: "Fund Formation & Syndication",
    image: "../assets/industries/agriculture.png",
    description:
      "Structuring SPVs, venture funds, and syndicates with compliant documentation, investor onboarding, and waterfall modeling."
}
    
];





// avisoryServices
export const globalExpansion = [
{
    id: 1,
    name: "Cross-Border Investment Facilitation ",
    image: "../assets/industries/agriculture.png",
    description:
      "Legal, tax, and regulatory guidance for international investments, including FDI structuring and global compliance."
  },
  {
    id: 2,
    name: "Market Entry & Localization Support",
    image: "../assets/industries/agriculture.png",
    description:
      "Strategic partnerships, local hiring, and go-to-market planning for portfolio companies expanding into new geographies."
    }
];

 


  



// Industries Data
export const performanceValue = [
  {
    id: 1,
    name: "Agriculture",
    image: "../assets/industries/agriculture.png",
    description:
      "Leveraging data-driven tools, IoT, and automation to increase productivity, precision, and sustainability in farming."
  },
  {
    id: 2,
    name: "Defense",
    image: "../assets/industries/defense.png",
    description:
      "Building secure, scalable, and mission-ready systems for defense, homeland security, and aerospace sectors."
  },
  {
    id: 3,
    name: "Automobile",
    image: "../assets/industries/automobile.png",
    description:
      "Accelerating innovation with connected vehicles, smart manufacturing, and mobility-as-a-service solutions."
  },
  {
    id: 4,
    name: "Energy",
    image: "../assets/industries/energy.png",
    description:
      "Driving digital energy transformation through smart grids, renewable integration, and predictive maintenance."
  }
];
